export default function CTA() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-14 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-5 md:px-6 text-center">
        <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-gray-900 mb-4 md:mb-6 leading-tight">
          Ready to Transform Your Business?
        </h2>

        <p className="text-sm md:text-lg text-gray-500 mb-7 md:mb-10">
          Connect with our experts for a complimentary consultation
        </p>

        <button
          onClick={scrollToContact}
          className="bg-amber-900 text-white px-8 py-3 md:px-12 md:py-4 rounded-full text-sm md:text-base font-medium hover:bg-amber-800 transition-colors inline-flex items-center gap-2 whitespace-nowrap"
        >
          Schedule Consultation
          <i className="ri-arrow-right-line"></i>
        </button>

        <div className="grid grid-cols-2 md:flex md:items-center md:justify-center gap-5 md:gap-10 mt-12 md:mt-20">
          {[
            { seq: 'partner-logo-001', alt: 'Technology Partner' },
            { seq: 'partner-logo-002', alt: 'Technology Partner' },
            { seq: 'partner-logo-003', alt: 'Technology Partner' },
            { seq: 'partner-logo-004', alt: 'Technology Partner' },
          ].map((p, i) => {
            const srcs = [
              "https://readdy.ai/api/search-image?query=Microsoft%20technology%20partner%20logo%20in%20monochrome%20style%2C%20clean%20corporate%20brand%20identity%2C%20simple%20black%20and%20white%20logo%20design%2C%20professional%20technology%20company%20branding%2C%20minimalist%20business%20logo%20on%20white%20background&width=200&height=100&seq=partner-logo-001&orientation=landscape",
              "https://readdy.ai/api/search-image?query=AWS%20Amazon%20Web%20Services%20partner%20logo%20in%20monochrome%20style%2C%20clean%20corporate%20brand%20identity%2C%20simple%20black%20and%20white%20logo%20design%2C%20professional%20cloud%20technology%20company%20branding%2C%20minimalist%20business%20logo%20on%20white%20background&width=200&height=100&seq=partner-logo-002&orientation=landscape",
              "https://readdy.ai/api/search-image?query=Oracle%20technology%20partner%20logo%20in%20monochrome%20style%2C%20clean%20corporate%20brand%20identity%2C%20simple%20black%20and%20white%20logo%20design%2C%20professional%20enterprise%20software%20company%20branding%2C%20minimalist%20business%20logo%20on%20white%20background&width=200&height=100&seq=partner-logo-003&orientation=landscape",
              "https://readdy.ai/api/search-image?query=SAP%20enterprise%20solutions%20partner%20logo%20in%20monochrome%20style%2C%20clean%20corporate%20brand%20identity%2C%20simple%20black%20and%20white%20logo%20design%2C%20professional%20business%20software%20company%20branding%2C%20minimalist%20business%20logo%20on%20white%20background&width=200&height=100&seq=partner-logo-004&orientation=landscape",
            ];
            return (
              <div key={i} className="w-24 h-10 md:w-32 md:h-12 flex items-center justify-center opacity-40 grayscale hover:grayscale-0 hover:opacity-100 transition-all mx-auto">
                <img src={srcs[i]} alt={p.alt} className="w-full h-full object-contain" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}